<div>
  <div class="mb-3 buscador">
    <div>
      <button class="btn btn-secundario" type="button" (click)="toggleDropdown()">
        {{ filterButtonLabel }}
        <i class="icon-equalizer"></i>
        <!-- <i class="fas fa-filter" aria-hidden="true"></i> -->
      </button>

      <div *ngIf="showDropdown" class="dropdown-content" role="menu" (mouseenter)="cancelCloseTimeout()"
        (mouseleave)="startCloseTimeout()">
        <div class="filter-content">
          <div class="clear-filter mb-3">
            <div>{{ "buttons.filter" | translate }}</div>
          </div>

          <!-- FILTER -->
         <!--  <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleAgent }">
                <input class="text" #agentInput type="text" (focus)="onFocus('agent')" (blur)="hideOptions()"
                  [(ngModel)]="agentSearchTerm" (input)="fillFilter(agentSearchTerm, 'agentData', 'agentAccounts')"
                  placeholder="{{ 'inputs.agent' | translate }}" [value]="displayTextAgent" />
                <span *ngIf="clearableAgent" class="clear-icon" (click)="
                  clearSelectedOption('agent'); $event.stopPropagation()
                "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleAgent" [ngClass]="{ visible: optionsVisibleAgent }">
                <div *ngFor="let agent of agentAccounts" class="option-value" (mousedown)="
                  onSelectAgent(agent,agentInput)">
                  <div><input type="checkbox" [checked]="agent.selected" /> <span class="checkbox-select">{{ agent.name
                      }} {{agent.lastname}}</span> </div>
                
                </div>
              </div>
            </div>
          </div> -->

      <!--     <div class="mb-3" *ngIf="filteredCampaigns.length > 0">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleCampaign }">
                <input class="text" #campaignInput type="text" (focus)="onFocus('campaign')" (blur)="hideOptions()"
                  [(ngModel)]="campaignSearchTerm" placeholder="{{ 'filter.campaign' | translate }}"
                  [value]="displayTextCampaign" />
                <span *ngIf="clearableCampaign" class="clear-icon" (click)="
                    clearSelectedOption('campaign'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleCampaign"
                [ngClass]="{ visible: optionsVisibleCampaign }">
                <div class="option-value" *ngFor="let campaign of filteredCampaigns"
                  (mousedown)="onSelectCampaign(campaign, campaignInput)">
                  <div>{{ campaign.name }}</div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleStage }">
                <input class="text" #stageInput type="text" (focus)="onFocus('stage')" (blur)="hideOptions()"
                  [(ngModel)]="stageSearchTerm" placeholder="{{ 'filter.stage' | translate }}"
                  (input)="fillFilter(stageSearchTerm,'stages','filteredStages')" [value]="displayTextStage" />
                <span *ngIf="clearableStage" class="clear-icon" (click)="
                    clearSelectedOption('stage'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleStage" [ngClass]="{ visible: optionsVisibleStage }">
                <div class="option-value" *ngFor="let stage of filteredStages"
                  (mousedown)="onSelectStage(stage, stageInput)">
                  <div><input type="checkbox" [checked]="stage.selected" /> <span class="checkbox-select">{{
                      "badge-status_select-stage."+stage.key | translate}}</span> </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleTelemarketingStatus }">
                <input class="text" #telemarketingStatusInput type="text" (focus)="onFocus('telemarketingStatus')" (blur)="hideOptions()"
                  [(ngModel)]="telemarketingStatusSearchTerm" placeholder="{{ 'filter.telemarketing_status' | translate }}"
                  [value]="displayTextTelemarketingStatus" />
                <span *ngIf="clearableTelemarketingStatus" class="clear-icon" (click)="
                    clearSelectedOption('telemarketingStatus'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleTelemarketingStatus" [ngClass]="{ visible: optionsVisibleTelemarketingStatus }">
                <div class="option-value" *ngFor="let telemarketingStatus of filteredTelemarketingStatus"
                  (mousedown)="onSelectTelemarketingStatus(telemarketingStatus, telemarketingStatusInput)">
                  <div>{{ telemarketingStatus.name }}</div>
                </div>
              </div>
            </div>
          </div> 

          <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleTelemarketingActionStatus }">
                <input class="text" #telemarketingActionStatusInput type="text" (focus)="onFocus('telemarketingActionStatus')" (blur)="hideOptions()"
                  [(ngModel)]="telemarketingActionStatusSearchTerm" placeholder="{{ 'filter.telemarketing_action_status' | translate }}"
                  [value]="displayTextTelemarketingActionStatus" />
                <span *ngIf="clearableTelemarketingActionStatus" class="clear-icon" (click)="
                    clearSelectedOption('telemarketingActionStatus'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleTelemarketingActionStatus" [ngClass]="{ visible: optionsVisibleTelemarketingActionStatus }">
                <div class="option-value" *ngFor="let telemarketingActionStatus of filteredTelemarketingActionStatus"
                  (mousedown)="onSelectTelemarketingActionStatus(telemarketingActionStatus, telemarketingActionStatusInput)">
                  <div>{{ telemarketingActionStatus.name }}</div>
                </div>
              </div>
            </div>
          </div> 

         <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleStatus }">
                <input class="text" #statusInput type="text" (focus)="onFocus('status')" (blur)="hideOptions()"
                  [(ngModel)]="statusSearchTerm" placeholder="{{ 'filter.status' | translate }}"
                  [value]="displayTextStatus" />
                <span *ngIf="clearableStatus" class="clear-icon" (click)="
                    clearSelectedOption('status'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleStatus" [ngClass]="{ visible: optionsVisibleStatus }">
                <div class="option-value" *ngFor="let status of filteredStatus"
                  (mousedown)="onSelectStatus(status, statusInput)">
                  <div>{{ "badge-status_select-stage."+status.key | translate}}</div>
                </div>
              </div>
            </div>
          </div> 


          <div class="mb-3" *ngIf="accountType !== 'broker'">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleBroker }">
                <input class="text" #brokerInput type="text" (focus)="onFocus('broker')" (blur)="hideOptions()"
                  [(ngModel)]="brokerSearchTerm" (input)="fillFilter(brokerSearchTerm, 'brokerData', 'brokerAccounts')"
                  placeholder="{{ 'inputs.broker' | translate }}" [value]="displayTextBroker" />
                <span *ngIf="clearableBroker" class="clear-icon" (click)="
                    clearSelectedOption('broker'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleBroker" [ngClass]="{ visible: optionsVisibleBroker }">
                <div *ngFor="let broker of brokerAccounts" class="option-value" (mousedown)="
                    onSelectBroker(broker,brokerInput)">
                  <div><input type="checkbox" [checked]="broker.selected" /> <span
                      class="checkbox-select">{{broker.name}}</span> </div>
                  <!--  <div>{{ broker.name }}</div> -->
                </div>
              </div>
            </div>
          </div>
<!-- 
          <div class="mb-3" *ngIf="accountType !== 'supplier'">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleSupplier }">
                <input class="text" #supplierInput type="text" (focus)="onFocus('supplier')" (blur)="hideOptions()"
                  [(ngModel)]="supplierSearchTerm"
                  (input)="fillFilter(supplierSearchTerm,'supplierData','supplierAccounts')"
                  placeholder="{{ 'inputs.supplier' | translate }}" [value]="displayTextSupplier" />
                <span *ngIf="clearableSupplier" class="clear-icon" (click)="
                    clearSelectedOption('supplier'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleSupplier"
                [ngClass]="{ visible: optionsVisibleSupplier }">
                <div *ngFor="
                    let supplier of supplierAccounts
                  " class="option-value" (mousedown)="onSelectSupplier(supplier, supplierInput)">
                  <div><input type="checkbox" [checked]="supplier.selected" /> <span
                      class="checkbox-select">{{supplier.name}}</span> </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="mb-3" *ngIf="accountType !== 'vendor'">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleVendor }">
                <input class="text" #vendorInput type="text" (focus)="onFocus('vendor')" (blur)="hideOptions()"
                  [(ngModel)]="vendorSearchTerm" (input)="fillFilter(vendorSearchTerm, 'vendorData', 'vendorAccounts')"
                  placeholder="{{ 'inputs.vendor' | translate }}" [value]="displayTextVendor" />
                <span *ngIf="clearableVendor" class="clear-icon" (click)="
                    clearSelectedOption('vendor'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleVendor" [ngClass]="{ visible: optionsVisibleVendor }">
                <div *ngFor="let vendor of vendorAccounts" class="option-value" (mousedown)="
                    onSelectVendor(vendor,vendorInput)">
                  <div><input type="checkbox" [checked]="vendor.selected" /> <span
                      class="checkbox-select">{{vendor.name}}</span> </div>
                </div>
              </div>
            </div>
          </div>


          

            <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleDeliveryStage }">
                <input class="text" #deliveryInput type="text" (focus)="onFocus('deliveryStage')" (blur)="hideOptions()"
                  [(ngModel)]="deliveryStageSearchTerm" placeholder="{{ 'filter.deliveryStage' | translate }}"
                  (input)="fillFilter(deliveryStageSearchTerm,'deliveryStage','filtereddeliverys')"
                  [value]="displayTextDeliveryStage" />
                <span *ngIf="clearableDeliveryStage" class="clear-icon" (click)="
                    clearSelectedOption('deliveryStage'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>

                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleDeliveryStage"
                [ngClass]="{ visible: optionsVisibleDeliveryStage }">
                <div class="option-value" *ngFor="let delivery of filteredDeliveryStages"
                  (mousedown)="onSelectDeliveryStage(delivery, deliveryInput)">
                  <div><input type="checkbox" [checked]="delivery.selected" /> <span class="checkbox-select">{{
                      "badge-status_select-stage."+delivery.key | translate}}</span> </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleBrand }">
                <input class="text" #brandInput type="text" (focus)="onFocus('brand')" (blur)="hideOptions()"
                  [(ngModel)]="brandSearchTerm" placeholder="{{ 'inputs.vehicle_brand' | translate }}"
                  (input)="fillFilter(brandSearchTerm, 'brands', 'filteredBrands')" [value]="displayTextBrand" />
                <span *ngIf="clearableBrand" class="clear-icon" (click)="
                    clearSelectedOption('brand'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleBrand" [ngClass]="{ visible: optionsVisibleBrand }">
                <div class="option-value" *ngFor="let brand of filteredBrands"
                  (mousedown)="onSelectBrand(brand, brandInput)">
                  <div><input type="checkbox" [checked]="brand.selected" /> <span
                      class="checkbox-select">{{brand.name}}</span> </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="main-selector-container">
              <div class="selector-container-supplier" [ngClass]="{ expanded: optionsVisibleModel }">
                <input class="text" #modelInput type="text" (focus)="onFocus('model')" (blur)="hideOptions()"
                  [(ngModel)]="modelSearchTerm" placeholder="{{ 'inputs.vehicle_model' | translate }}"
                  (input)="searchModels(modelSearchTerm)" [value]="displayTextModel" />
                <span *ngIf="clearableModel" class="clear-icon" (click)="
                    clearSelectedOption('model'); $event.stopPropagation()
                  "><i class="icon-cross2"></i></span>
                <span class="icon-chevron-down"></span>
              </div>
              <div class="options-container" *ngIf="optionsVisibleModel" [ngClass]="{ visible: optionsVisibleModel }">
                <div class="option-value" *ngFor="let model of filteredModels"
                  (mousedown)="onSelectModel(model, modelInput)">
                  <div>{{ model.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showClear" class="clear">
      <button class="btn btn-hover clear-button" type="button" (click)="clearFilter($event)">
        {{ "buttons.clearFilter" | translate }}
      </button>
    </div>
    <!-- <div>
      <button class="btn" type="button" (click)="openExportOptions()" >Exportar<i class="icon-download"></i></button>
    </div> -->
  </div>

</div>
